import React, { useState } from 'react'
import ManualRegistration from '../sections/ManualRegistration'
import { postRegistrations } from '../services/dashboard.service'
import { toast } from 'react-toastify'
import { getApiErrorMessage } from '../utils/error'

const NewRegistration = () => {
  const [isLoading, setIsLoading] = useState(false)

  const onSubmit = async (e) => {
    try {
      setIsLoading(true)
      e.preventDefault()
      const data = new FormData(e.target)
      if (!data.get('profileImage')) {
        alert('Foto profil harus diisi')
        return
      }
      if (!data.get('ktpImage')) {
        alert('Foto KTP harus diisi')
        return
      }
      data.set('type', 'MANUAL NEW')
      data.append('files', data.get('ktpImage'))
      data.delete('ktpImage')
      data.append('files', data.get('profileImage'))
      data.delete('profileImage')

      await postRegistrations(data)
      toast.success('Berhasil registrasi')
      setTimeout(() => {
        window.location.href = '/'
      }, 400)
    } catch (error) {
      toast.error(getApiErrorMessage(error, 'Gagal menyimpan registrasi'))
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <ManualRegistration
      onSubmit={onSubmit}
      title="Daftar KTA Baru"
      isLoading={isLoading}
    />
  )
}

export default NewRegistration
